module.exports = __webpack_public_path__ + "static/about-3-b2b9532b8ac8712bfca6da4eb899e690.jpg";